import { useTranslation } from 'react-i18next';
import { MessageCircle, PenTool, Clock, Check } from 'lucide-react';

// How-we-work timeline shown on the homepage: the free 7-day mockup pitch.
const STEP_ICONS = [MessageCircle, PenTool, Clock, Check];

export function ProcessSection() {
  const { t } = useTranslation('home');
  const steps = t('process.steps', { returnObjects: true }) as { title: string; desc: string }[];

  return (
    <section className="relative py-20 sm:py-24">
      {/* Subtle background gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-neon-cyan/5 to-transparent pointer-events-none" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <h2 className="text-2xl sm:text-3xl font-bold text-text-primary font-heading">
            {t('process.title')}
          </h2>
          <p className="mt-2 text-text-secondary">{t('process.subtitle')}</p>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Connecting gradient line (desktop only) */}
          <div className="hidden sm:block absolute top-7 left-[12.5%] right-[12.5%] h-px bg-gradient-to-r from-neon-cyan/30 via-neon-purple/30 to-neon-cyan/30" />

          <div className="grid grid-cols-1 sm:grid-cols-4 gap-8 sm:gap-4">
            {steps.map((step, index) => {
              const Icon = STEP_ICONS[index] ?? Check;
              return (
                <div key={index} className="relative flex flex-col items-center text-center">
                  {/* Numbered icon node */}
                  <div className="relative w-14 h-14 rounded-full glass-card border border-white/10 flex items-center justify-center mb-5">
                    <Icon className="w-6 h-6 text-neon-cyan" />
                    <span className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-gradient-to-r from-neon-cyan to-neon-purple text-white text-xs font-bold flex items-center justify-center">
                      {String(index + 1).padStart(2, '0')}
                    </span>
                  </div>
                  <h3 className="font-semibold text-text-primary font-heading mb-1.5">{step.title}</h3>
                  <p className="text-sm text-text-secondary leading-relaxed max-w-[14rem]">{step.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
